// src/security/actions.catalog.ts
import { type RouteCategory } from "./routes.catalog";

/**
 * Permiso de accion (un boton/funcion) evaluado contra `Role.rules`, no contra el
 * plan de suscripcion. Para el gating por plan ver `features.catalog.ts`.
 *
 * Va en un catalogo aparte de `PRIVATE_ROUTE_CATALOG` a proposito: `resolveRouteId`
 * itera ese array y entradas sin `path` real lo contaminarian.
 *
 * Para agregar un permiso nuevo: registrar aqui el id estable (namespace `action:`)
 * y consultarlo con `canDo` de `useRoleAccess`.
 */
export type ActionNode = {
    /** ID estable para autorizacion (no cambiar una vez publicado) */
    id: string;
    /** Etiqueta para la UI de permisos del rol */
    label: string;
    /** Categoria funcional (para agrupar en el acordeon) */
    category: RouteCategory;
    /** Descripcion opcional */
    description?: string;
};

export const ROLE_ACTION_CATALOG: ActionNode[] = [
    {
        id: "action:quote:approve",
        label: "Aprobar Cotizacion",
        category: "invoicing",
        description: "Marcar una cotizacion como aprobada para poder facturarla",
    },
    {
        id: "action:quote:block",
        label: "Bloquear Cotizacion",
        category: "invoicing",
        description: "Bloquear una cotizacion para impedir que se facture",
    },
];
